import { render, staticRenderFns } from "./carPlate.vue?vue&type=template&id=2a5b05a7&scoped=true&"
import script from "./carPlate.vue?vue&type=script&lang=js&"
export * from "./carPlate.vue?vue&type=script&lang=js&"
import style0 from "./carPlate.vue?vue&type=style&index=0&id=2a5b05a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b05a7",
  null
  
)

export default component.exports